// tslint:disable-next-line:max-line-length
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Options, ChangeContext } from 'ng5-slider';
import { UntypedFormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Slider } from 'src/app/model/slider';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { YourPension } from '../../model/ngrx/your-pension.model';
import { AppState } from '../../store/state/app.state';
import { UtilService } from '../../shared';
import { CurrencyFunctionalityService } from '../../shared/utilities/functionality/currency-functionality.service';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';

@Component({
  selector: 'app-simple-slider',
  templateUrl: './simple-slider.component.html',
  styleUrls: ['./simple-slider.component.scss']
})
export class SimpleSliderComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @Input() sliderConfig: Slider;
  @Input() parent: UntypedFormGroup;
  @Input() controlName: string;
  @Input() sliderId: string;
  @Input() disable: boolean;
  @Input() fundAmount: number;
  @Input() enableTooltip: boolean = false;
  @Output() calculatedValueClickHandler: EventEmitter<number> = new EventEmitter<number>();
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onScrollEndHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output() goToDependantsPageSSHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDisplayMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();
  manualRefresh: EventEmitter<void> = new EventEmitter<void>();
  yourPensionStore: Observable<YourPension[]>;
  yourPensionData: YourPension;
  calculatedValueLumpSum: string;
  subscription: any;
  value = null;
  options: Options = {
    floor: null,
    ceil: null,
    translate: null,
    showTicksValues: true,
    disabled: true,
    stepsArray: [
      // { value: 0 },
      // { value: 50 },
      // { value: 67 },
      // { value: 100 }
    ]
  };
  defaultStyle = true;
  yourPensionACE;
  constructor(private store: Store<AppState>, private currencyFunctionalityService: CurrencyFunctionalityService,
    private utilService: UtilService, private activatedRoute: ActivatedRoute, private ref: ChangeDetectorRef,
    private router: Router) {
    this.yourPensionStore = store.select(STORE_VAL.your_pension);
    this.yourPensionACE = this.activatedRoute.snapshot.data.contentData.yourPension;
    this.yourPensionStore.subscribe(res => {
      if (res.length > 0) {
        this.yourPensionData = res[0];
      }
    });
  }

  ngOnInit() {
    this.setSlderValues();
    this.calculate(this.value, this.sliderConfig);
    this.subscription = this.utilService.emitSlider.subscribe(
      (values) => {
        // if (this.controlName === 'taxfreelumpsum') {
        //   this.options.ceil = 11;
        // }
        this.setSlderValues('scrollEnd', values);
      }
    );
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.disable) {
      // this.disable = changes.disable.currentValue;
      this.setSlderValues();
    } else {
      this.value = changes.parent.currentValue.controls[this.controlName].value;
      if (this.value && this.sliderConfig) {
        if (changes.parent.currentValue.controls['productType'] &&
          changes.parent.currentValue.controls['productType'].value === 'H' &&
          this.controlName === 'periodofincome') {
          this.setSlderValues();
        }
        this.calculate(this.value, this.sliderConfig);
      }
    }
  }
  setSlderValues = (navType?: string, fundAmount?: number) => {
    this.value = this.parent.controls[this.controlName].value;
    if (this.sliderConfig.stepsArray && this.sliderConfig.stepsArray.length > 0) {
      this.options = {
        floor: this.sliderConfig.minValue,
        ceil: this.sliderConfig.maxValue,
        disabled: this.disable,
        translate: (value: number): string => {
          return (this.sliderConfig.sliderType === 'Years' || this.sliderConfig.sliderType === 'Months') ? value.toString() : value + '%';
        },
        showTicksValues: true,
        stepsArray: this.sliderConfig.stepsArray
      };
      // tslint:disable-next-line:max-line-length
    } else if (this.sliderConfig.sliderType === 'Price' || (this.sliderConfig.sliderType === 'Percentage' && !this.sliderConfig.sliderTitle)) {
      this.options = {
        floor: this.sliderConfig.minValue,
        ceil: this.sliderConfig.maxValue,
        disabled: this.disable,
        translate: (value: number): string => {
          return (value ? value : 0) + '%';
        }
      };
    } else {
      this.options = {
        floor: this.sliderConfig.minValue,
        ceil: this.sliderConfig.maxValue,
        disabled: this.disable,
      };
    }
    this.calculate(this.value, this.sliderConfig, navType, fundAmount);
  }
  calculate = (val, sliderConfig, type?: string, fundAmount?: number) => {
    // Added custom style for range slider on change
    const id = this.sliderId;
    if (this.controlName && this.controlName === 'sldrtaxfreeSlider' &&
      this.sliderConfig['fundAmount']) {
      fundAmount = this.sliderConfig['fundAmount'];
    }
    if (!type && id && sliderConfig.stepsArray.length > 0) {
      const slider = document.getElementById(id);
      if (slider) {
        const elems = slider.getElementsByClassName('ng5-slider-tick');
        // if (elems && elems.length > 0 && elems[1].getElementsByClassName('ng5-slider-tick')
        //   && elems[1].getElementsByClassName('ng5-slider-tick').length > 0) {
        Array.from(elems).forEach((elem) => {
          //console.log(elem.textContent);
          const element = parseInt(elem.textContent.trim().replace('%', ''));
          const currElem = elem.getElementsByClassName('ng5-slider-tick-value');
          if (element === val && currElem && currElem.length > 0) {
            currElem[0].getElementsByClassName('ng5-slider-inner-tooltip')[0].classList.add('selected');
          } else {
            currElem[0].getElementsByClassName('ng5-slider-inner-tooltip')[0].classList.remove('selected');
          }

        });
      }
    }
    if (!val) {
      val = 0;
    }
    if (sliderConfig && sliderConfig.sliderType === 'Percentage') {
      val = val.toString();
      if (val.includes('%')) {
        val = val.replace('%', '');
      }
      this.calculatedValueLumpSum = val + '%';
      this.calculatedValueClickHandler.emit(val);
      return val + '%';
    } else if ((this.yourPensionData || fundAmount) && sliderConfig && sliderConfig.sliderType === 'Price') {
      let pensionAmount = 0;
      // if (this.yourPensionData.cedingFund) {
      //   pensionAmount = this.yourPensionData.cedingFund;
      // } else {
      //   pensionAmount = this.yourPensionData.totalSum;
      // }
      if (fundAmount) {
        val = (fundAmount * val) / 100;
      } else {
        pensionAmount = this.fundAmount ? this.fundAmount :
          (this.yourPensionData.cedingFund ? this.yourPensionData.cedingFund : this.yourPensionData.totalSum);
          if(pensionAmount && pensionAmount != null && isNaN(pensionAmount)) {
            pensionAmount = Number((pensionAmount).toString().replace(/,/g, ''));  
          }

        val = (pensionAmount * val) / 100;
      }
      this.calculatedValueClickHandler.emit(val);
      const reg = new RegExp('^-?\\d+(?:\.\\d{0,' + (2 || -1) + '})?');
      let formattedCurrency = val.toString().match(reg)[0];
      formattedCurrency = parseFloat(formattedCurrency).toFixed(2);
      // tslint:disable-next-line:max-line-length
      // const test = CurrencyFunctionalityService.convertNumberToCurrency(formattedCurrency).toString().match(/^-?\d+(?:\.\d{0,2})?/);
      // tslint:disable-next-line:max-line-length
      this.calculatedValueLumpSum = '£' + CurrencyFunctionalityService.convertNumberToCurrency(formattedCurrency);
      // this.calculatedValueLumpSum = '£' + val.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      // return '£' + Math.round(val).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return this.calculatedValueLumpSum;
    } else if (this.router.url !== '/apply/your-pension-savings') {
      this.calculatedValueClickHandler.emit(val);
      this.calculatedValueLumpSum = val;
      return val;
    }
  }
  /* common method for converting string into camel case */
  camelCase(idValue) {
    return idValue.toLowerCase()
      // Replaces any - or _ characters with a space
      .replace(/[-_]+/g, ' ')
      // Removes any non alphanumeric characters
      .replace(/[^\w\s]/g, '')
      // Uppercases the first character in each group immediately following a space
      // (delimited by spaces)
      .replace(/ (.)/g, function ($1) { return $1.toUpperCase(); })
      // Removes spaces
      .replace(/ /g, '');
  }
  onUserChangeEnd(changeContext: ChangeContext, sliderConfig, controlName): void {
    // changeContext.sliderParams = this.sliderConfig;
    // tslint:disable-next-line:no-debugger
    sliderConfig.controlName = controlName;
    sliderConfig.currentValue = changeContext.value;
    this.onScrollEndHandler.emit(sliderConfig);
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  goToDependantsPageSS() {
    this.goToDependantsPageSSHandler.emit();
  }
  
  setMinLTA = (errorMessage): string => {
    let MinValue = this.yourPensionACE.minPensionValue; 
    if(this.parent  && this.parent['value'] && this.parent['value']['productType'])  { 
      MinValue = (this.parent['value']['productType'] != 'C') ?  this.yourPensionACE.GIAPensionValue : this.yourPensionACE.minPensionValue;
    }
    errorMessage = errorMessage.replace('[LTAMin]',
      CurrencyFunctionalityService.convertNumberToCurrency(MinValue));
    return errorMessage;
  }
  ngAfterViewInit() {
    this.ref.detectChanges();
  }
  displayMobileTooltipSliderReceiver() {
    this.onDisplayMobileTooltipEmitter.emit();
  }
}
